import React from "react";
import ReactDOM from "react-dom";
import InputCountry from "../../component/InputCountry/InputCountry";


class CountryInput {
  render() {
    const e = React.createElement;
    const elements = document.querySelectorAll('.initCountryInput');

    elements.forEach((element, key) => {
      ReactDOM.render(
        e(InputCountry, {}),
        element
      );
    })
  }
}

export default CountryInput;